import React from 'react';
import * as PropTypes from 'prop-types';
import { Container } from '@si-armes/dsfr-react';
import ErreurPossessionEtape3 from './erreur-possession/ErreurPossessionEtape3';
import InformationsIncorrectesEtape3 from './informations-incorrectes/InformationsIncorrectesEtape3';

const SignalerErreurEtape3 = ({ signalerArmeData, etapePrecedente, tableauConfigHeader }) => {
    return (
        <Container fluid={false} className="margin-top-md">
            {signalerArmeData.typeErreur === 'non-possession' ? (
                <ErreurPossessionEtape3
                    etapePrecedente={etapePrecedente}
                    signalerArmeData={signalerArmeData}
                />
            ) : null}
            {signalerArmeData.typeErreur === 'information-incorrectes' ? (
                <InformationsIncorrectesEtape3
                    etapePrecedente={etapePrecedente}
                    signalerArmeData={signalerArmeData}
                    tableauConfigHeader={tableauConfigHeader}
                />
            ) : null}
        </Container>
    );
};

SignalerErreurEtape3.propTypes = {
    etapePrecedente: PropTypes.func.isRequired,
    signalerArmeData: PropTypes.shape({
        typeErreur: PropTypes.string.isRequired,
    }).isRequired,
    tableauConfigHeader: PropTypes.array.isRequired,
};

export default SignalerErreurEtape3;
